import { t } from 'i18next';

import { renderCell } from './DeployedPipelinesTable/cellRenderers';
import { useDeploymentsContext } from '../context/DeploymentsContext';

import { Table } from '~/components/Table/Table';

const TABLE_COLUMNS = [
  {
    key: 'pipelineName',
    label: t('label.pipeline')
  },
  {
    key: 'deployStatus',
    label: t('label.status')
  },
  {
    key: 'deploymentSize',
    label: t('label.size')
  },
  {
    key: 'deploymentConcurrentExecutions',
    label: t('label.concurrent_executions_short')
  },
  {
    key: 'deploymentReplicas',
    label: t('label.replicas')
  },
  {
    key: 'deployedBy',
    label: t('label.deployed_by')
  },
  {
    key: 'deploymentActions',
    label: t('label.actions'),
    hideLabel: true
  }
];

export function DeploymentsListView() {
  const {
    loading,
    onPageChange,
    rowsPerPage,
    deploymentsList,
    deploymentsData,
    menuActionHandlers
  } = useDeploymentsContext();

  const pages = deploymentsList?.totalPages || 0;
  const currentPage = (deploymentsList?.number || 0) + 1;
  return (
    <Table
      ariaLabel='deployed-pipelines-table'
      data={deploymentsData}
      columns={TABLE_COLUMNS}
      hideHeader={false}
      useFlexLayout={false}
      isLoading={loading}
      rowsPerPage={rowsPerPage}
      pages={pages}
      currentPage={currentPage}
      onPageChange={onPageChange}
      onRowClick={item => menuActionHandlers.onClick(item.deployment)}
      renderCell={props =>
        renderCell({ ...props, handlers: menuActionHandlers })
      }
    />
  );
}
